module.exports = __webpack_public_path__ + "img/SoldierNETLogo.3762ab0f.png";